import { UserGroup } from '@shared/interfaces';

export const pdfPageWidthOnLandscape = 282;
export const noGroup: UserGroup = { id: 0, name: '', isDefault: false };
export const missingGroupFromUrl = -1;
